import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'result',
    label: 'Result',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
